import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

const AI_SESSION_KEY = "ismotech_ai_session";

export function getAiSession() {
  let sid = localStorage.getItem(AI_SESSION_KEY);
  if (!sid) {
    sid = "s-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(AI_SESSION_KEY, sid);
  }
  return sid;
}

export function resetAiSession() {
  const sid = "s-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
  localStorage.setItem(AI_SESSION_KEY, sid);
  return sid;
}

const get = (url) => api.get(url).then((r) => r.data);

export function trackActivity(payload) {
  const body = { session_id: getAiSession(), ...payload };
  api.post("/ai/activity", body).catch(() => {});
}

export const useAiConfig = () =>
  useQuery({ queryKey: ["ai-config"], queryFn: () => get("/ai/config"), staleTime: 300000, retry: false });

export const useAiNotifications = (enabled = true) =>
  useQuery({
    queryKey: ["ai-notifications"],
    queryFn: () => get("/ai/notifications"),
    enabled,
    refetchInterval: 30000,
    retry: false,
  });

export const useAdminAnalytics = (enabled = true) =>
  useQuery({ queryKey: ["ai-admin-analytics"], queryFn: () => get("/ai/admin/analytics"), enabled, retry: false });

export const useAdminActiveVisitors = (enabled = true) =>
  useQuery({
    queryKey: ["ai-admin-visitors"],
    queryFn: () => get("/ai/admin/active-visitors"),
    enabled,
    refetchInterval: 30000,
    retry: false,
  });

export const useVendorInsights = (enabled = true) =>
  useQuery({
    queryKey: ["ai-vendor-insights"],
    queryFn: () => get("/ai/vendor/insights"),
    enabled,
    refetchInterval: 45000,
    retry: false,
  });
